import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import AddressManagement from './AddressManagement';
import AddAddressModal from './AddAddressModal';
import EditAddressModal from './EditAddressModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import Loader from './Loader';
import { globalLogout } from '../../Utils/Logout';
import Footer from '../../Components/Footer/Footer';
const AddressManagementPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const fetchAddresses = async () => {
    try {
      const token = Cookies.get("ecom_user_token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-shipping-addresses`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAddresses(response.data.shippingAddresses || []);
    } catch (err) {
      globalLogout(err)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleAddAddress = async (newAddress) => {
    setIsProcessing(true);
    try {
      const token = Cookies.get("ecom_user_token");
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-shipping-address`,
        newAddress,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchAddresses();
      setShowAddModal(false);
      toast.success("Address added successfully!");
    } catch (err) {
       globalLogout(err)
    } finally {
      setIsProcessing(false);
    }
  };

  const handleUpdateAddress = async (updatedAddress) => {
    setIsProcessing(true);
    try {
      const token = Cookies.get("ecom_user_token");
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/update-shipping-address`,
        {
          addressId: selectedAddress._id,
          ...updatedAddress
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchAddresses();
             setShowEditModal(false);

      toast.success("Address updated successfully!");
    } catch (err) {
      globalLogout(err)
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDeleteAddress = async () => {
    setIsProcessing(true);
    try {
      const token = Cookies.get("ecom_user_token");
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-shipping-address/${selectedAddress._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchAddresses();
      setShowDeleteModal(false);
      toast.success("Address deleted successfully!");
    } catch (err) {
      globalLogout(err)
    } finally {
      setIsProcessing(false);
    }
  };

  if (loading) return <Loader fullScreen />;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Manage Addresses</h1>
      
      <AddressManagement 
        addresses={addresses}
        onAddClick={() => setShowAddModal(true)}
        onEditClick={(address) => {
          console.log("Editing address:", address); // Debug log
          setSelectedAddress(address);
          setShowEditModal(true);
        }}
        onDeleteClick={(address) => {
          setSelectedAddress(address);
          setShowDeleteModal(true);
        }}
      />
      
      <AddAddressModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSubmit={handleAddAddress}
        isProcessing={isProcessing}
      />
      
      {selectedAddress && (
        <>
          <EditAddressModal
            isOpen={showEditModal}
            onClose={() => setShowEditModal(false)}
            onSubmit={handleUpdateAddress}
            initialData={selectedAddress}
            isProcessing={isProcessing}
          />
          
          <DeleteConfirmationModal
            isOpen={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleDeleteAddress}
            isProcessing={isProcessing}
          />
        </>
      )}
      
    </div>
    
  );
};

export default AddressManagementPage;